import { InplaceDesignTokens } from '@primeuix/themes/aura/inplace';

export const inplaceTokens: InplaceDesignTokens = {
  root: {
    padding: '{form.field.padding.y} {form.field.padding.x}',
    borderRadius: '{content.border.radius}',
    transitionDuration: '{transition.duration}',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
  },
  display: {
    hoverBackground: '{content.hover.background}',
    hoverColor: '{content.hover.color}',
  },
};
